(function (window) {
  'use strict';

  var requests = new Map();
  var supportedSchemaVersion = 1;

  function timeoutFetch(url, timeoutMs) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer;
    var request = fetch(url, {
      credentials: 'same-origin',
      signal: controller ? controller.signal : undefined,
      headers: { Accept: 'application/json' }
    });
    var timeout = new Promise(function (_, reject) {
      timer = window.setTimeout(function () {
        if (controller) controller.abort();
        reject(new Error('Configurator data request timed out.'));
      }, timeoutMs || 30000);
    });

    return Promise.race([request, timeout]).finally(function () {
      window.clearTimeout(timer);
    });
  }

  function sha256(text) {
    if (!window.crypto || !window.crypto.subtle || typeof TextEncoder !== 'function') {
      return Promise.resolve(null);
    }
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buffer) {
      return Array.prototype.map.call(new Uint8Array(buffer), function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  function normalizeRecord(record) {
    if (typeof record === 'string') {
      return { url: record, checksumSha256: '', schemaVersion: supportedSchemaVersion };
    }
    return record || null;
  }

  function loadRecord(record, validator) {
    record = normalizeRecord(record);
    if (!record || !record.url) {
      return Promise.reject(new Error('Configurator data asset is not mapped.'));
    }
    if (Number(record.schemaVersion || 0) !== supportedSchemaVersion) {
      return Promise.reject(new Error('Unsupported configurator data schema.'));
    }

    var cacheKey = [record.url, record.checksumSha256 || ''].join('|');
    if (requests.has(cacheKey)) return requests.get(cacheKey);

    var request = timeoutFetch(record.url, Number(record.timeoutMs) || 30000)
      .then(function (response) {
        if (!response.ok) throw new Error('Configurator data request failed with HTTP ' + response.status + '.');
        return response.text();
      })
      .then(function (text) {
        return sha256(text).then(function (checksum) {
          if (checksum && record.checksumSha256 && checksum !== record.checksumSha256) {
            throw new Error('Configurator data checksum mismatch.');
          }
          var payload = JSON.parse(text);
          if (!validator(payload)) throw new Error('Configurator data has an invalid shape.');
          return payload;
        });
      })
      .catch(function (error) {
        requests.delete(cacheKey);
        throw error;
      });

    requests.set(cacheKey, request);
    return request;
  }

  function blindRecord(productId) {
    return window.CustomConfiguratorDataMap &&
      window.CustomConfiguratorDataMap.blinds &&
      window.CustomConfiguratorDataMap.blinds.products &&
      window.CustomConfiguratorDataMap.blinds.products[String(productId)];
  }

  function draperyRecord(style, locale) {
    var styles = window.CustomConfiguratorDataMap &&
      window.CustomConfiguratorDataMap.drapery &&
      window.CustomConfiguratorDataMap.drapery.styles;
    return styles && styles[style] && styles[style][locale === 'en' ? 'en' : 'fr'];
  }

  window.CustomConfiguratorLoader = Object.freeze({
    loadBlindProduct: function (productId) {
      return loadRecord(blindRecord(productId), function (payload) {
        return payload && payload.product && String(payload.product.id) === String(productId) &&
          Array.isArray(payload.color_groups);
      });
    },
    loadDrapery: function (style, locale) {
      return loadRecord(draperyRecord(style, locale), function (payload) {
        return payload && payload.success === true && Array.isArray(payload.categories) &&
          payload.fabrics && typeof payload.fabrics === 'object';
      });
    },
    clearCache: function () {
      requests.clear();
    }
  });
}(window));
